import { useContext } from 'react'

import { OtaAppContext } from './OtaAppContext'

export const useOtaAppContext = () => useContext(OtaAppContext)
